<template>
<el-drawer
    title="挂单记录"
    v-if="hangVisible"
    size="95%"
    :visible.sync="hangVisible"
    @close="close">
    <section class="row">
      <asideContent ref="ording" invoicesType="1" @sendObj="getCurOrderObj" style="margin-top:-10px;"></asideContent>
      <section class="section-main" v-if="orderId"
        v-loading="infoDetailLoading"
        element-loading-text="请稍后，全力加载中..."
        element-loading-spinner="el-icon-loading">
        <section class="goods">
          <section class="hang-table">
            <div class="goods-top row align-center" style="border-bottom:1px solid #e1e1e1;width:100%;margin-bottom:15px;">
              <span style="margin-right: 10px;height: 20px;width: 4px;background: #067cf2;"></span>
              <p>货品信息</p>
            </div>
            <grid-manager v-if="goodsTable.length" :option="gridOption"></grid-manager>
            <div class="table-total row space-end align-center" v-if="orderData">
              <div>总件数：<span>{{ orderData.totalCount || "0" }}</span>件</div>
              <div>总金额：<span>￥{{ orderData.totalRealPrice || "0.00" }}</span></div>
            </div>
          </section>

          <section class="goods-card">
            <template v-if="orderData">
              <div class="goods-title row align-center" style="border-bottom:1px solid #e1e1e1;width:98%;">
                <span style="margin-right: 10px;height: 20px;width: 4px;background: #067cf2;"></span>
                <p>单据信息</p>
              </div>
              <div class="row space-around goods-obj">
                <div class="goods-item">
                  <div>
                    销售状态：<span>已挂起</span>
                  </div>
                  <div>
                    店铺名称：<span>{{ orderData.deptName }}</span>
                  </div>
                  <div>
                    业绩方式：<span>{{
                      orderData.brokerage === '1'
                        ? "个人业绩"
                        : orderData.brokerage === '4'
                        ? "历练公单"
                        : ""
                    }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    销售单号：<span>{{ orderData.orderNo }}</span>
                  </div>
                  <div>
                    订单性质：<span>{{ orderData.orderTypeTitle }}</span>
                  </div>
                  <div v-if="orderData.brokerage === '1' && orderData.shoppingGuideName">
                    营业员：<span>{{ orderData.shoppingGuideName }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    单据来源：<span>{{
                      orderData.source === '1' ? "手机端" : orderData.source === '2' ? "客户端" : ''
                    }}</span>
                  </div>
                  <div>
                    创建时间：<span>{{ orderData.createTime }}</span>
                  </div>
                  <div v-if="orderData.createTerminalTitle">创建订单收银台：<span>{{orderData.createTerminalTitle}}</span></div>
                </div>
              </div>
              <div class="row" style="margin: -8px 10px 0;" v-if="orderData.brokerage === '2' && orderData.shoppingGuideName">
                <span style="color:#999;">班组人员：</span><span class="description">{{ orderData.shoppingGuideName }}</span>
              </div>
            </template>
          </section>
          <section class="goods-card">
            <template v-if="vipData && vipData.phone">
              <div class="goods-title row align-center" style="border-bottom:1px solid #e1e1e1;width:98%;margin-bottom:15px;">
                <span style="margin-right: 10px;height: 20px;width: 4px;background: #067cf2;"></span>
                <p>会员信息</p>
              </div>
              <div class="row space-around goods-obj">
                <div class="goods-item">
                  <div>
                    会员昵称：<span>{{ vipData.nickname }}</span>
                  </div>
                  <div>
                    会员卡号：<span>{{ vipData.cardNumber }}</span>
                  </div>
                  <div>
                    累计消费金额：<span>{{ vipData.totalSellAmount }}</span>
                  </div>
                  <div>
                    件单价：<span>{{ vipData.unitPrice }}</span>
                  </div>
                  <div>
                    会员优惠券：<span>{{ vipData.realName }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    开卡时间：<span>{{ vipData.createTime }}</span>
                  </div>
                  <div>
                    累计消费次数：<span>{{ vipData.totalSellCount }}</span>
                  </div>
                  <div>
                    会员积分：<span>{{ vipData.integralBalance }}</span>
                  </div>
                </div>
                <div class="goods-item">
                  <div>
                    手机号：<span>{{ vipData.phone }}</span>
                  </div>
                  <div>
                    开卡店铺：<span>{{ vipData.deptName }}</span>
                  </div>
                  <div>
                    平均消费金额：<span>{{ vipData.avgSellAmount }}</span>
                  </div>
                  <div>
                    会员余额：<span>{{ vipData.accountBalance }}</span>
                  </div>
                </div>
              </div>
            </template>
          </section>
        </section>
        <section class="bot-fixed row align-center">
          <div class="tools-btn" @click="deleteCurHang" style="background: #43435C;">删除</div>
          <div class="tools-btn" @click="sureFetch" style="background: #DD8595;">确认取单</div>
        </section>
      </section>
      <section class="section-main" style="background: #fff" v-else>
        <noDataState textDesc="暂无订单详情数据" marginTop="280"></noDataState>
      </section>
    </section>
</el-drawer>
</template>

<script>
import asideContent from "@/views/salesRecord/components/asideContent";
import noDataState from "@/components/noDataState.vue";
import { takeOutPendingList, queryInvoicesInfo } from "@/libs/http/modules/posOrder";
export default {
  components: {
    asideContent,
    noDataState,
  },
  data() {
    return {
      gridOption: {
        gridManagerName: "hangRecordGrid",
        firstLoading: true,
        height: "400px",
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: "goodsName",
            text: "货品信息",
            align: "center",
            width: "310px",
            template: () => {
              return `
                <div class="row align-center" style="text-align:left;">
                  <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;">
                    <el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
                    <div v-else style="width:102px;height:92px;border-radius:4px;text-align:center;line-height:92px;color:#999;background:#f5f5f5;">暂无图片</div>
                    <div v-if="row.activeId || [0, 1, 2, 3].includes(row.couponType)"
                      style="
                      width:70px;height:22px;line-height:22px;position:absolute;top:4px;right:-19px;transform: rotate(45deg);text-align:center;
                      background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400);color:#fff;font-size:12px;">
                      {{row.activeId ? '促销' : '核销'}}
                    </div>
                  </div>
                  <div class="column" style="margin-left:10px;flex:1;">
                    <template v-if="![1, 2].includes(row.couponType)">
                      <div style="font-size:18px;color:#333;">{{row.goodsName}}</div>
                      <div style="font-size:14px;color:#999;margin:10px 0;">货号：{{row.goodsNo}}</div>
                      <div style="font-size:14px;color:#999;">条码：{{row.barCode}}</div>
                    </template>
                    <template v-else>
                      <div>{{row.couponTypeName}}</div>
                      <div style="width: 100%;white-space: pre-wrap;">{{row.name}}</div>
                    </template>
                  </div>
                </div>
              `;
            },
          },
          {
            key: "colorDesc",
            text: "颜色 / 尺码",
            align: "center",
            width: "150px",
            template: () => {
              return `
                        <div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
                            <p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
                                <span v-if="index == 0" style="margin:0 3px;">,</span>
                            </p>
                        </div>
                    `;
            },
          },
          {
            key: "number",
            text: "数量",
            align: "center",
            width: "120px",
            template: () => {
              return `
                        <div style="font-size:20px;">
                            {{row.number}}
                        </div>
                        `;
            },
          },
          {
            key: "unitRealPrice",
            text: "实卖价(单价)",
            align: "center",
            width: "120px",
            template: () => {
              return `
                        <div v-if="![1, 2].includes(row.couponType)" class="row align-center space-center">
                            <span style="color:#666;font-size:20px;">￥{{row.unitRealPrice}}</span>
                        </div>
                    `;
            },
          },
          {
            key: "tagPrice",
            text: "吊牌价",
            align: "center",
            template: () => {
              return `
                        <div class="row align-center space-center">
                            <span style="font-size:20px;">￥{{row.tagPrice}}</span>
                        </div>
                    `;
            },
          },
          {
            key: "discount",
            text: "折扣",
            align: "center",
            template: () => {
              return `
                        <div v-if="![1, 2].includes(row.couponType)" class="row align-center space-center">
                            <span style="font-size:20px;">{{(row.unitRealPrice / row.tagPrice * 10).toFixed(1)}}折</span>
                        </div>
                    `;
            },
          },
          {
            key: "money",
            text: "金额(元)",
            align: "center",
            template: () => {
              return `
                        <div class="row align-center space-center" style="color:#F8475F;font-size:20px;">
                            ￥{{row.totalRealPrice}}
                        </div>
                    `;
            },
          },
        ],
        ajaxData: this.showGoodsTable
      },
      goodsTable: [],
      orderData: null,
      vipData: null,
      orderId: '',
      invoicesNo: "",
      infoDetailLoading: false,
      hangVisible: true,
      hasCoupon: false
    };
  },
  created(){
    this.$nextTick(()=>{
      this.$refs.ording.queryHangList();
    })
  },
  methods: {
    close(){
      this.$emit('close');
    },
    getCurOrderObj(e) {
      if (e && e.id && e.invoicesNo) {
        this.orderId = e.id;
        this.invoicesNo = e.invoicesNo;
        this.queryInvoices(e.first);
      } else {
        this.orderId = "";
        this.invoicesNo = "";
      }
    },
    queryInvoices() {
      this.infoDetailLoading = true;
      queryInvoicesInfo({
        orderId: this.orderId
      })
      .then(data => {
        if (data.storeInfo) {
          let list = []
          if(data.couponInfoList && data.couponInfoList.length){
            this.hasCoupon = true
            data.couponInfoList.forEach(item=>{
              if([1, 2].includes(item.couponType)){
                list.push(item)
              }
            })
          }else{
            this.hasCoupon = false
          }
          this.goodsTable = [...data.storeInfo, ...list];
          GridManager.refreshGrid(this.gridOption.gridManagerName);
        }
        this.orderData = data.orderInfo || null;
        this.vipData = data.memberInfo || null;
        setTimeout(()=>{
          this.infoDetailLoading = false;
        },500);
      })
      .catch(err => {
        this.$message({
          type: "error",
          message: err,
          duration: 2000,
          showClose: true,
        });
        this.infoDetailLoading = false;
      });
    },
    showGoodsTable() {
      if (this.goodsTable.length) {
        return new Promise((resolve, reject) => {
          const tableData = {
            data: this.goodsTable,
          };
          resolve(tableData);
        });
      }
    },
    deleteCurHang() {
      let strText = ''
      if(this.hasCoupon){
        strText = `删除后无法恢复挂单记录，确定删除？<br/><br/>使用了第三方优惠券，删除挂单会先尝试撤销优惠券，若撤销优惠券失败（超时效），需要顾客到第三方渠道操作退券。`
      }else{
        strText = '删除后无法恢复挂单记录，确定删除？'
      }
      this.$confirm(strText, "删除提示", {
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$refs.ording.deleteCurOrding(this.hasCoupon)
      }).catch((err) => {})
    },
    sureFetch() {
      this.$confirm("确认提取该订单数据", "取单提示").then(() => {
		    const cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
        this.infoDetailLoading = true;
        takeOutPendingList({
          isUpdate: 'N',
          id: this.orderId,
          terminalId: cashierItem ? cashierItem.id : ''
        }).then(data => {
          this.$emit('getOrder', data);
          this.$refs.ording.delecardList();
          this.infoDetailLoading = false;
          this.close();
        }).catch(err => {
          this.infoDetailLoading = false;
          this.$message({ type: "error", message: err, duration: 2000, showClose: true });
        });
      }).catch(err => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  display: inline-block;
  line-height: 20px;
}
.section-main {
  width: calc(100% - 520px);
  height: calc(100vh - 90px);
  margin-top: 10px;
  position: relative;
  .bot-fixed {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
    height: 60px;
    box-shadow: 0px -2px 16px 0px rgba(4, 51, 97, 0.1);
    border-radius: 2px;
    font-family: "font-Regular";
    z-index: 9;
    .tools-btn {
      border-radius: 4px;
      color: #fff;
      width: 100px;
      text-align: center;
      line-height: 40px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
.goods {
  height: calc(100vh - 140px);
  overflow: auto;
  .goods-top {
    font-family: "font-Medium";
    color: #656d78;
    padding-bottom: 12px;
  }
  .hang-table {
    background: #fff;
    padding: 0 10px;
    .table-total {
      height: 50px;
      border-top: 1px solid #f5f5f5;
      font-family: "font-Light";
      > div {
        margin-right: 20px;
      }
      span {
        color: #f8475f;
        font-size: 20px;
        font-family: "font-Medium";
      }
    }
  }
  .goods-card {
    background: #fff;
    margin-top: 10px;
    font-family: "font-Light";
    font-size: 14px;
    .goods-title {
      font-size: 18px;
      font-family: "font-Medium";
      color: #656d78;
      width: 180px;
      padding: 10px 0;
      margin: 0 10px;
    }
    .goods-obj {
      flex: 1;
      color: #999;
      padding: 10px;
      .goods-item {
        width: calc(100% / 3);
        div {
          line-height: 30px;
          span {
            color: #000;
          }
        }
      }
    }
  }
}
</style>

<style>
.hang-table .table-wrap {
  height: auto !important;
}
</style>